module.exports = __webpack_public_path__ + "static/img/banner_10.69a40bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_10.png
// module id = YX2f
// module chunks = 16